export const en = {
    'incorrect-ecommerce': 'Ecommerce data transfer incorrectly configured',
    'new-auditory': 'Showed interest in similar products',
    'product-page-visit': 'Viewed products on my site',
    'same-products': 'Both groups',
    'similar-goods-for-search':
        'In search results, ads will only be shown to users who are interested in similar products',
    'status-active': 'Active',
    'status-hint-not-show': 'No data ',
    'status-hint-only-for-context': 'Impressions in ad networks only',
    'status-hint-show-not-everyone': 'Showing not for all audience',
    'status-stopped': 'Off',
    'unavailable-for-search': 'Adding this criteria will exclude impressions on search'
};
